// Vue
import { defineStore } from 'pinia';

// Store
//import { useCommonStore } from '@/stores/common/commonStore';
import { useLoginStore } from '@/stores/login/loginStore';
//import { useTouStore } from '@/stores/common/touStore';

// Utils
//import Utils from '@/commonProject/helpers/utils.js';

// Instance
//const router = useRouter();
//const loginStore = useLoginStore();
//const commonStore = useCommonStore();
//const touStore = useTouStore();

export const useHeaderStore = defineStore({
    id: 'header',
    state: () => ({}),
    getters: {},
    actions: {
        async logoutAction() {
            const loginStore = useLoginStore();

            // Cognitoログアウト処理
            await loginStore.cognitoLogoutAction();
        },
    },
});
